__turbopack_context__.v({
  "answer": "style-module-scss-module__-HlxgW__answer",
  "component": "style-module-scss-module__-HlxgW__component",
  "heading": "style-module-scss-module__-HlxgW__heading",
  "item": "style-module-scss-module__-HlxgW__item",
  "list": "style-module-scss-module__-HlxgW__list",
  "question": "style-module-scss-module__-HlxgW__question",
});
